// extracted by mini-css-extract-plugin
export default {"container":"Forbidden_container__9+wzn","content":"Forbidden_content__IIzWu"};